module.exports = __webpack_public_path__ + "img/mana.034e32c2.svg";